module.exports = ".toggle-wrapper {\n  width: 50px;\n  height: 50px;\n  position: absolute;\n  right: 100px;\n  bottom: 20px; }\n  .toggle-wrapper img {\n    width: 50px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dimensions-toggle/dimensions-toggle.component.scss
// module id = ./src/app/dimensions-toggle/dimensions-toggle.component.scss
// module chunks = main